import React, { Fragment, useState } from 'react'
import ProjectInitiation from '../../Common/Component/ProjectInitiation';

const AsmUserProjectInit = () => {
    return (
        <Fragment>
            <ProjectInitiation />
        </Fragment>
    )
}

export default AsmUserProjectInit